import { CheckForm } from 'components/CheckForm/CheckForm';
import { Input } from 'components/Input/Input';
import { Link } from 'components/Link/Link';
import { Button } from 'components/buttons/Button/Button';
import React from 'react';

const SubsctibeCard = ({ title, description, policy }) => {
    const [agreed, setAgreed] = React.useState(true);

    const onAgreed = value => {
        setAgreed(value);
    };
    return (
        <div className="subscribe-card">
            <div className="subscribe-card__label">
                <div className="subscribe-card__label-label">• Stay up to date</div>
                <svg width="287" height="80" viewBox="0 0 287 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M286.069 80V16C286.069 7.16345 278.906 0 270.069 0H0C3.9104 0 7.6853 1.43201 10.6119 4.02554L73.7448 59.9745C76.6714 62.568 80.4463 64 84.3567 64H270.069C278.906 64 286.069 71.1635 286.069 80Z"
                        fill="#ffffff"
                    />
                </svg>
            </div>
            <div className="subscribe-card__content">
                <h2>{title}</h2>
                <p className="body1 opacity-80">{description}</p>
                <div className="subscribe-form">
                    <div className="subscribe-form__input">
                        <Input type="email" placeholder="Your E-mail" name="mail" />
                        <Button type={`send ${!agreed ? 'disabled' : ''}`} />
                    </div>
                    <CheckForm onClick={onAgreed} checked={agreed}>
                        <span dangerouslySetInnerHTML={{ __html: policy }} />
                    </CheckForm>
                </div>
            </div>
            {/* Thanks state */}
            {/* <div className="subscribe-card__content">
                <h2>Thanks for subscribing to our newsletter!</h2>
                <p className="body1 opacity-80">
                    We're constantly publishing fresh news and research, that will help expand your knowledge of the
                    current challenges in the agricultural industry.
                </p>
            </div> */}
        </div>
    );
};

export default SubsctibeCard;
